(() => {
  const columnControls = document.querySelectorAll('[data-collection-column-control]');
  const productGrids = document.querySelectorAll('[data-product-grid]');
  const mobileColumnCounts = new Set(['1', '2', '3']);
  const desktopColumnCounts = new Set(['3', '4', '5']);
  const mobileColumnStorageKey = 'wob.collection.mobileColumns';
  const desktopColumnStorageKey = 'wob.collection.desktopColumns';
  const desktopColumnQuery = window.matchMedia?.('(min-width: 750px)');

  const readStoredColumnCount = (storageKey, validColumnCounts) => {
    try {
      const storedColumnCount = window.localStorage.getItem(storageKey);

      return validColumnCounts.has(storedColumnCount) ? storedColumnCount : null;
    } catch (error) {
      return null;
    }
  };

  const writeStoredColumnCount = (storageKey, columnCount) => {
    try {
      window.localStorage.setItem(storageKey, columnCount);
    } catch (error) {
      // Local storage can be unavailable in strict privacy contexts.
    }
  };

  let mobileColumnCount = readStoredColumnCount(mobileColumnStorageKey, mobileColumnCounts) || productGrids[0]?.dataset.mobileColumns || '2';
  let desktopColumnCount = readStoredColumnCount(desktopColumnStorageKey, desktopColumnCounts) || productGrids[0]?.dataset.desktopColumns || '5';

  const syncColumnControls = () => {
    const isDesktop = desktopColumnQuery?.matches;
    const activeColumnCount = isDesktop ? desktopColumnCount : mobileColumnCount;

    columnControls.forEach((control) => {
      control.querySelectorAll('[data-collection-columns]').forEach((button) => {
        const isActive = button.dataset.collectionColumns === activeColumnCount;

        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    });
  };

  const setColumnCount = (columnCount, { persist = false, viewport = null } = {}) => {
    const targetViewport = viewport || (desktopColumnQuery?.matches ? 'desktop' : 'mobile');
    const isDesktop = targetViewport === 'desktop';
    const validColumnCounts = isDesktop ? desktopColumnCounts : mobileColumnCounts;
    const nextColumnCount = validColumnCounts.has(columnCount) ? columnCount : (isDesktop ? '5' : '2');

    if (isDesktop) {
      desktopColumnCount = nextColumnCount;
      document.documentElement.dataset.collectionDesktopColumns = nextColumnCount;

      productGrids.forEach((grid) => {
        grid.dataset.desktopColumns = nextColumnCount;
      });
    } else {
      mobileColumnCount = nextColumnCount;
      document.documentElement.dataset.collectionMobileColumns = nextColumnCount;

      productGrids.forEach((grid) => {
        grid.dataset.mobileColumns = nextColumnCount;
      });
    }

    syncColumnControls();

    if (persist) {
      writeStoredColumnCount(isDesktop ? desktopColumnStorageKey : mobileColumnStorageKey, nextColumnCount);
    }
  };

  if (columnControls.length && productGrids.length) {
    setColumnCount(mobileColumnCount, { viewport: 'mobile' });
    setColumnCount(desktopColumnCount, { viewport: 'desktop' });

    columnControls.forEach((control) => {
      control.addEventListener('click', (event) => {
        const button = event.target instanceof Element ? event.target.closest('[data-collection-columns]') : null;

        if (!(button instanceof HTMLButtonElement)) return;

        setColumnCount(button.dataset.collectionColumns, { persist: true });
      });
    });

    desktopColumnQuery?.addEventListener?.('change', syncColumnControls);
  }

  const scrollTopButtons = document.querySelectorAll('[data-collection-scroll-top]');
  const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)');
  const scrollTopDesktopQuery = window.matchMedia?.('(min-width: 750px)');
  const scrollTopDesktopGap = 12;
  const scrollTopViewportInset = 16;
  let scrollTopUpdateQueued = false;
  let scrollTopPositionUpdateQueued = false;

  const updateScrollTopButtonPosition = (button) => {
    if (scrollTopDesktopQuery && !scrollTopDesktopQuery.matches) {
      button.style.removeProperty('--collection-scroll-top-left');
      return;
    }

    const wrapper = button.closest('.page-width');
    const wrapperRect = wrapper?.getBoundingClientRect();
    const buttonWidth = Math.ceil(button.offsetWidth);

    if (!wrapperRect || !buttonWidth) {
      button.style.removeProperty('--collection-scroll-top-left');
      return;
    }

    const wrapperLeft = Math.max(wrapperRect.left, scrollTopViewportInset);
    const outsideLeft = wrapperLeft - buttonWidth - scrollTopDesktopGap;
    const nextLeft = outsideLeft >= scrollTopViewportInset ? outsideLeft : wrapperLeft;

    button.style.setProperty('--collection-scroll-top-left', `${Math.round(nextLeft)}px`);
  };

  const updateScrollTopButtons = ({ updatePosition = false } = {}) => {
    const showAfter = Math.max(420, window.innerHeight * 0.72);
    const isVisible = window.scrollY > showAfter;

    scrollTopButtons.forEach((button) => {
      if (!(button instanceof HTMLButtonElement)) return;

      button.hidden = false;
      if (updatePosition) updateScrollTopButtonPosition(button);
      button.classList.toggle('is-visible', isVisible);
      button.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
      button.tabIndex = isVisible ? 0 : -1;
    });
  };

  const requestScrollTopUpdate = () => {
    if (scrollTopUpdateQueued) return;

    scrollTopUpdateQueued = true;
    window.requestAnimationFrame(() => {
      scrollTopUpdateQueued = false;
      updateScrollTopButtons();
    });
  };

  const requestScrollTopPositionUpdate = () => {
    if (scrollTopPositionUpdateQueued) return;

    scrollTopPositionUpdateQueued = true;
    window.requestAnimationFrame(() => {
      scrollTopPositionUpdateQueued = false;
      updateScrollTopButtons({ updatePosition: true });
    });
  };

  if (scrollTopButtons.length) {
    scrollTopButtons.forEach((button) => {
      if (!(button instanceof HTMLButtonElement)) return;

      button.addEventListener('click', () => {
        window.scrollTo({
          top: 0,
          behavior: prefersReducedMotion?.matches ? 'auto' : 'smooth'
        });
      });
    });

    updateScrollTopButtons({ updatePosition: true });
    window.addEventListener('scroll', requestScrollTopUpdate, { passive: true });
    window.addEventListener('resize', requestScrollTopPositionUpdate);
    if (document.fonts?.ready) {
      document.fonts.ready.then(requestScrollTopPositionUpdate).catch(() => {});
    }
  }
})();
